import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'
import { setNotification } from './general/slice'

export const errorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        api.dispatch(setNotification([typeof action.payload === 'string' ? action.payload : 'Server Error ...', 'error']));
    }

    return next(action);
};